import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Field } from 'formik';
import MaskedInput from 'react-text-mask';
import {
    Card,
    CardContent,
    AppBar,
    Toolbar,
    Typography,
    TextField as CTextField,
} from '@material-ui/core';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from 'formik-material-ui';
import { atualizarGrupo, getGrupoById } from '../../services/GruposApi';
import EnderecoGrupoMap from '../../components/Grupo/EnderecoGrupoMap';
import EnderecoGrupoMarker from '../../components/Grupo/EnderecoGrupoMarker';

function TimeMask(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[/\d/, /\d/, ':', /\d/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
    },
    pastor: {
        margin: theme.spacing(1),
        minWidth: 300,
    },
    coordenador: {
        margin: theme.spacing(1),
        minWidth: 300,
    },
    dia: {
        margin: theme.spacing(1),
        minWidth: 150,
    },
    horario: {
        margin: theme.spacing(1),
        maxWidth: 100,
    },
    endereco: {
        margin: theme.spacing(1),
    },
    numero: {
        margin: theme.spacing(1),
        maxWidth: 100,
    },
    bairro: {
        margin: theme.spacing(1),
        minWidth: 250,
    },
    mapButton: {
        marginTop: 12,
        marginBottom: 12,
        margin: theme.spacing(1),
    },
    button: {
        marginTop: 24,
        margin: theme.spacing(1),
    },
    error: {
        color: '#e53935',
        fontSize: 11,
    },
}));

const renderMap = status => {
    if (status === Status.LOADING) return <h3>{status} ..</h3>;
    if (status === Status.FAILURE) return <h3>{status} ...</h3>;
    return null;
};

const pastores = [
    { id: 3951, nome: 'EKNER DE CARVALHO NUNES' },
    { id: 7442, nome: 'ISRAEL VIEIRA DE BARROS' },
    { id: 1706, nome: 'KELSON E SILVA CÂMARA' },
    { id: 3050, nome: 'ROSINALDO RODRIGUES DA SILVA' },
    { id: 2958, nome: 'SILVESTRE AUGUSTO DE ARAÚJO CASTRO' },
    { id: 3218, nome: 'VAGNER DA SILVA RODRIGUES' },
];

const coordenadores = [
    { id: 3514, nome: 'ADEMIR OLAVO AZEVEDO FERREIRA FILHO' },
    { id: 4891, nome: 'ANDERSON FABIANO SOUZA SANTOS' },
    { id: 4123, nome: 'ALAIN GIAN RIBEIRO DA COSTA' },
    { id: 4940, nome: 'ALTAIR GERMANO NAZARETH' },
    { id: 8719, nome: 'CLAILTON COSTA DE OLIVEIRA' },
    { id: 5822, nome: 'CLÁUDIO MOIZÉS DECARES' },
    { id: 7853, nome: 'CLÍCIO FREIRE DA SILVA' },
    { id: 6557, nome: 'DAVI AMAZONAS DA SILVA' },
    { id: 3727, nome: 'DELMER DE OLIVEIRA CARVALHO PEREIRA' },
    { id: 5628, nome: 'EVALDO DE SOUZA MELO' },
    { id: 7296, nome: 'FRANCISCO DAS CHAGAS AQUINO DINIZ' },
    { id: 3510, nome: 'FRANCISCO DAS CHAGAS MACHADO SALES' },
    { id: 6119, nome: 'GEORGINO GOMES DA SILVA' },
    { id: 7641, nome: 'HAYDENILSON SANTOS DE ANDRADE' },
    { id: 7549, nome: 'HENRY ROSAS PEREIRA' },
    { id: 2840, nome: 'HILLERMANN FERREIRA OSMÍDIO LIMA' },
    { id: 3097, nome: 'ISAAC MALVEIRA CABRAL' },
    { id: 2775, nome: 'JOSÉ HÉRICO OLIVEIRA DE ARAÚJO' },
    { id: 6472, nome: 'JOSÉ NOBREGA DA FONTE NETO' },
    { id: 5063, nome: 'JOSÉ VICENTE PEREIRA CARNEIRO' },
    { id: 12427, nome: 'JOSELINO CAMPOS DE SOUSA' },
    { id: 6889, nome: 'JOSENARIO BARACHO DE FIGUEIREDO' },
    { id: 6593, nome: 'JULIANO PAVÃO RODRIGUES' },
    { id: 4392, nome: 'LUIZ ANDRÉ FERNANDES COSTA' },
    { id: 2175, nome: 'MARCELO AUGUSTO DE SOUZA RIBEIRO DA COSTA' },
    { id: 10009, nome: 'MARCIO PINTO DE OLIVEIRA GOES' },
    { id: 8502, nome: 'MARCOS PAULO RODRIGUES DUTRA' },
    { id: 5551, nome: 'MARCO AURÉLIO ARAÚJO DE MEDEIROS' },
    { id: 3134, nome: 'MICHAEL MENEZES GURGEL' },
    { id: 3499, nome: 'PERCY PAULO MATANIA GOMES FIDÉLIS' },
    { id: 2967, nome: 'PETERSON DE MATOS RIBEIRO' },
    { id: 9211, nome: 'RENATO PINHEIRO DA COSTA' },
    { id: 6924, nome: 'RICARDO CEZAR MONTEIRO DA ROCHA' },
    { id: 2216, nome: 'ROSELY VIDÉO DE SOUZA' },
    { id: 7095, nome: 'SAMUEL CARLOS RIBEIRO DA SILVA' },
    { id: 9089, nome: 'STENIO WICTOR FLORES ANTUNES' },
    { id: 7915, nome: 'SULEMAR DO NASCIMENTO BARROSO' },
    { id: 6595, nome: 'CAIO ARAÚJO' },
    { id: 3613, nome: 'FLÁVIO CARVALHO CAVALCANTE' },
    { id: 1560, nome: 'JARDEL BECKER' },
    { id: 14125, nome: 'PAULO VITORIANO' },
    { id: 6184, nome: 'WALCIMAR MAIA RODRIGUES' },
    { id: 3147, nome: 'WASHINGTON ABTIBOL' },
];

coordenadores.sort((a, b) => a.nome.localeCompare(b.nome));

export default function AtualizarGrupo(props) {
    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;

    const classes = useStyles();
    const history = useHistory();
    const [grupo, setGrupo] = useState({
        idPastor: '',
        idCoordenador: '',
        nbDiaSemanaReuniao: '',
        txHorarioReuniao: '',
        txEndereco: '',
        txNumero: '',
        txBairro: '',
    });
    const [center, setCenter] = useState({
        lat: -3.045104,
        lng: -60.024065,
    });
    const [position, setPosition] = useState({
        lat: -3.045104,
        lng: -60.024065,
    });
    const [address, setAddress] = useState('');
    const { idGrupoPequeno } = useParams();

    const zoom = 18;

    const updatePosition = e => {
        setPosition(e.latLng.toJSON());
    };

    const geocodeAddress = formFields => {
        setAddress(
            `${formFields.txEndereco}, ${formFields.txNumero}, ${formFields.txBairro}, Manaus - AM`
        );
    };

    const onGeocodeSuccess = latLng => {
        setCenter(latLng);
        setPosition(latLng);
        setAddress('');
    };

    function handleCancelar() {
        history.goBack();
    }

    async function fetchGrupo(idGrupo) {
        try {
            const response = await (await getGrupoById(idGrupo)).data;
            setGrupo(response);

            if (response.nbLatitude && response.nbLongitude) {
                setCenter({
                    lat: Number(response.nbLatitude),
                    lng: Number(response.nbLongitude),
                });
                setPosition({
                    lat: Number(response.nbLatitude),
                    lng: Number(response.nbLongitude),
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleSalvar = async (values, { setSubmitting }) => {
        try {
            const grupoTemp = {
                idGrupoPequeno: grupo.idGrupoPequeno,
                idPastor: values.pastor.id ?? null,
                idCoordenador: values.coordenador.id ?? null,
                nbDiaSemanaReuniao: values.nbDia,
                txHorarioReuniao: values.txHorario,
                txEndereco: values.txEndereco.toUpperCase(),
                txNumero: values.txNumero,
                txBairro: values.txBairro.toUpperCase(),
                nbLatitude: position.lat,
                nbLongitude: position.lng,
            };
            await atualizarGrupo(idGrupoPequeno, grupoTemp);
            history.goBack();
        } catch (err) {
            if (err.response.status === 500) {
                // setInformacao(true);
            }
        }

        setSubmitting(false);
    };

    useEffect(() => {
        fetchGrupo(idGrupoPequeno);
    }, [idGrupoPequeno]);

    return (
        <>
            <AppBar position="static">
                <Toolbar>
                    <Typography color="secondary" variant="h5">
                        Dados do GA
                    </Typography>
                </Toolbar>
            </AppBar>
            <Card>
                <CardContent>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            pastor: grupo.idPastor
                                ? {
                                      id: grupo.idPastor,
                                      nome: grupo.txPastor,
                                  }
                                : { nome: '' },
                            coordenador: grupo.idCoordenador
                                ? {
                                      id: grupo.idCoordenador,
                                      nome: grupo.txCoordenador,
                                  }
                                : { nome: '' },
                            nbDia: grupo.nbDiaSemanaReuniao ?? '',
                            txHorario: grupo.txHorarioReuniao,
                            txEndereco: grupo.txEndereco,
                            txNumero: grupo.txNumero,
                            txBairro: grupo.txBairro,
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            handleSalvar(values, { setSubmitting });
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={Yup.object().shape({
                            nbDia: Yup.string().required(
                                'Dia deve ser informado'
                            ),
                            txHorario: Yup.string()
                                .matches(timeRegex, 'Horário Inválido')
                                .required('Horário deve ser informado'),
                            txEndereco: Yup.string().required(
                                'Endereço deve ser informado'
                            ),
                        })}
                    >
                        {props => {
                            const {
                                touched,
                                errors,
                                isSubmitting,
                                submitForm,
                                values,
                                setFieldValue,
                            } = props;
                            return (
                                <form noValidate autoComplete="off">
                                    <Grid container spacing={3}>
                                        {(grupo.nbTipo == 4 ||
                                            grupo.nbTipo == 5 ||
                                            grupo.nbTipo == 6) && (
                                            <Grid item xs={12}>
                                                <FormControl
                                                    className={classes.pastor}
                                                >
                                                    <Autocomplete
                                                        required
                                                        disableClearable
                                                        options={pastores}
                                                        value={values.pastor}
                                                        style={{ width: 380 }}
                                                        getOptionLabel={option =>
                                                            option.nome
                                                        }
                                                        onChange={(
                                                            e,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'pastor',
                                                                value
                                                            );
                                                        }}
                                                        renderInput={params => (
                                                            <CTextField
                                                                {...params}
                                                                label="Pastor"
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    className={
                                                        classes.coordenador
                                                    }
                                                >
                                                    <Autocomplete
                                                        required
                                                        disableClearable
                                                        options={coordenadores}
                                                        value={
                                                            values.coordenador
                                                        }
                                                        style={{ width: 380 }}
                                                        error={
                                                            errors.coordenador
                                                        }
                                                        getOptionLabel={option =>
                                                            option.nome
                                                        }
                                                        onChange={(
                                                            e,
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'coordenador',
                                                                value
                                                            );
                                                        }}
                                                        renderInput={params => (
                                                            <CTextField
                                                                {...params}
                                                                label="Coordenador"
                                                            />
                                                        )}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        )}
                                        <Grid item xs={12}>
                                            <FormControl
                                                className={classes.dia}
                                            >
                                                <InputLabel>Dia</InputLabel>
                                                <Field
                                                    required
                                                    component={Select}
                                                    name="nbDia"
                                                    value={values.nbDia}
                                                    error={errors.nbDia}
                                                    onChange={(e, value) => {
                                                        setFieldValue(
                                                            'nbDia',
                                                            value
                                                                ? value.props
                                                                      .value
                                                                : '1'
                                                        );
                                                    }}
                                                >
                                                    <MenuItem value="1">
                                                        SEGUNDA-FEIRA
                                                    </MenuItem>
                                                    <MenuItem value="2">
                                                        TERÇA-FEIRA
                                                    </MenuItem>
                                                    <MenuItem value="3">
                                                        QUARTA-FEIRA
                                                    </MenuItem>
                                                    <MenuItem value="4">
                                                        QUINTA-FEIRA
                                                    </MenuItem>
                                                    <MenuItem value="5">
                                                        SEXTA-FEIRA
                                                    </MenuItem>
                                                    <MenuItem value="6">
                                                        SÁBADO
                                                    </MenuItem>
                                                </Field>
                                                {errors.nbDia && (
                                                    <div
                                                        className={
                                                            classes.error
                                                        }
                                                    >
                                                        {errors.nbDia}
                                                    </div>
                                                )}
                                            </FormControl>
                                            <Field
                                                component={TextField}
                                                label="Horário"
                                                name="txHorario"
                                                className={classes.horario}
                                                required
                                                InputProps={{
                                                    inputComponent: TimeMask,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Field
                                                required
                                                autoFocus
                                                fullWidth
                                                component={TextField}
                                                label="Endereço"
                                                name="txEndereco"
                                                className={classes.endereco}
                                                inputProps={{
                                                    style: {
                                                        textTransform:
                                                            'uppercase',
                                                    },
                                                    maxLength: 70,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <Field
                                                component={TextField}
                                                label="Número"
                                                name="txNumero"
                                                id="txNumero"
                                                className={classes.numero}
                                                inputProps={{
                                                    style: {
                                                        textTransform:
                                                            'uppercase',
                                                    },
                                                    maxLength: 5,
                                                }}
                                            />
                                            <Field
                                                component={TextField}
                                                label="Bairro"
                                                name="txBairro"
                                                id="txBairro"
                                                className={classes.bairro}
                                                inputProps={{
                                                    style: {
                                                        textTransform:
                                                            'uppercase',
                                                    },
                                                    maxLength: 30,
                                                }}
                                            />
                                            <Button
                                                variant="outlined"
                                                onClick={() => {
                                                    geocodeAddress(values);
                                                }}
                                                className={classes.mapButton}
                                                type="button"
                                            >
                                                Posicionar no Mapa
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Wrapper
                                                apiKey="AIzaSyAtQHDG0cnR-zxpj4qi0--QcoLMM6wGoK8"
                                                render={renderMap}
                                            >
                                                <EnderecoGrupoMap
                                                    center={center}
                                                    zoom={zoom}
                                                    address={address}
                                                    onClick={updatePosition}
                                                    onGeocodeSuccess={
                                                        onGeocodeSuccess
                                                    }
                                                >
                                                    <EnderecoGrupoMarker
                                                        position={position}
                                                    />
                                                </EnderecoGrupoMap>
                                            </Wrapper>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Button
                                                variant="contained"
                                                onClick={submitForm}
                                                color="primary"
                                                disabled={isSubmitting}
                                                className={classes.button}
                                            >
                                                Salvar
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleCancelar}
                                                disabled={isSubmitting}
                                                className={classes.button}
                                                type="button"
                                            >
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            );
                        }}
                    </Formik>
                </CardContent>
            </Card>
        </>
    );
}
